export default "__VITE_ASSET__BsbXTaKj__"